import * as Sentry from '@sentry/react';

export function initSentry() {
  if (!import.meta.env.VITE_SENTRY_REACT_DSN) {
    return;
  }

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_REACT_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    release: import.meta.env.VITE_SENTRY_RELEASE,

    sendDefaultPii: false,

    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,

    sampleRate: 0.25,

    allowUrls: [
    //   /https:\/\/kinoway\.ru/,
    //   /https:\/\/www\.kinoway\.ru/,
    //   /https:\/\/devkinoway\.ru/,
      /https:\/\/devkinoway\.altercup\.ru/,
      /https:\/\/kinoway\.altercup\.ru/,
      /https:\/\/kinoway\.tv/,
    ],

    denyUrls: [
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
    ],

    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Network Error',
      'Failed to fetch',
      'AbortError',
      'Non-Error promise rejection captured',
    ],
  });
}
